import React, { useContext, useEffect, useState } from 'react';
import Box from '../../components/single_component/Box';
import SalesWelcomeBox from '../../components/common_component/SalesWelcomeBox';
import SalesDeveloperDataTable from '../componets/SalesDeveloperDataTable';
import SalesDashboardContext from '../../context/SalesDashBoardContext';
import TransactionDataTable from '../componets/SalesTransactionTable';
import DateUtils from '../../utils/dateUtils';
import AuthContext from '../../context/AuthContext';

const durationNames = [
  "Today's",
  'Weekly',
  'Monthly',
  'Quarterly',
  'Half-Yearly',
  'Yearly',
];

function SalesDashContainer() {
  const { DashBoardData, getDashboardData } = useContext(SalesDashboardContext);
  const { dataFormat, transactions } = DashBoardData;
  const [duration, setDuration] = useState(2);
  const { masterData } = useContext(AuthContext);
  const data = masterData?.value();
  const [Page, setPage] = React.useState(1);
  const [rowsPerPage, setrowsPerPage] = React.useState(10);
  const [Next, setNext] = React.useState();
  const [Previous, setPrevious] = React.useState();
  const [currPage, setcurrPage] = React.useState(1);
  const [StartDate, setStartDate] = useState<any>(null);
  const [EndDate, setEndDate] = useState<any>(null);
  const [filterToggle, setFilterToggle] = useState(false);
  const [selectedChip, setSelectedChip] = React.useState(-1);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const startDate = DateUtils.formatDate(StartDate, 'YYYY-MM-DD');
    const endDate = DateUtils.formatDate(EndDate, 'YYYY-MM-DD');
    const transcStatus = data?.transactionStatus[selectedChip] ?? '';
    setLoading(true);
    await getDashboardData(
      `sales/dashboard?page=${currPage}&size=${rowsPerPage}`,
      {
        filter: {
          duration,
          ...(transcStatus && { transcStatus: [transcStatus] }),
          ...(startDate && startDate !== 'Invalid date' && { startDate }),
          ...(endDate && endDate !== 'Invalid date' && { endDate }),
        },
      }
    );
    setLoading(false);
    setFilterToggle(false);
  };
  useEffect(() => {
    setPage(transactions?.totalPages);
    setNext(transactions?.nextPage);
    setPrevious(transactions?.prevPage);
  }, [transactions]);

  useEffect(() => {}, [DashBoardData]);

  useEffect(() => {
    fetchData();
  }, [currPage, rowsPerPage]);

  return (
    <Box style={{ paddingBottom: 6, paddingTop: 3 }}>
      <Box style={{ width: '85%', margin: 'auto' }}>
        <Box style={{ marginBottom: 4, marginTop: 4 }}>
          <SalesWelcomeBox />
        </Box>
        <TransactionDataTable
          extra={{
            data: transactions ?? [],
            Page,
            setPage,
            rowsPerPage,
            setrowsPerPage,
            Next,
            setNext,
            Previous,
            setPrevious,
            currPage,
            setcurrPage,
            StartDate,
            setStartDate,
            EndDate,
            setEndDate,
            duration,
            setDuration,
            durationNames,
            filterToggle,
            setFilterToggle,
            selectedChip,
            setSelectedChip,
            fetchData,
            loading,
          }}
        />
        <Box
          style={{
            marginTop: 8,
            boxShadow: '0px 2px 10px 0px #10496030',
            borderRadius: 10,
          }}>
          <SalesDeveloperDataTable
            extra={{ data: dataFormat ?? [], loading }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SalesDashContainer;
